import "@/src/styles/globals.css";

let fileName = "";
let fileData = "";

document.addEventListener("DOMContentLoaded", () => {
	const form = document.querySelector("#form");
	const fileInput = document.querySelector("#receipt") as HTMLInputElement;
	if (fileInput) {
		fileInput.addEventListener("change", handleFileChange);
	}
	if (form) {
		form.addEventListener("submit", handleFormSubmit);
	}
});

export const handleFormSubmit = (event: Event) => {
	event.preventDefault();
	const formTop = document.querySelector("#form-top");
	const form = event.target as HTMLFormElement;
	const formData = new FormData(form);
	const data = Object.fromEntries(formData.entries());

	console.log(fileName, fileData);
	if (fileName && fileData) {
		data.receipt = {
			name: fileName,
			data: fileData,
		} as any;
	}

	const API_URL =
		data?.lang === "cz"
			? "./backend/create_registration.php"
			: "../backend/create_registration.php";
	fetch(API_URL, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	})
		.then((response) => response.json())
		.then((data) => {
			formTop && formTop.scrollIntoView({ behavior: "smooth" });
			if (data.status) {
				form.classList.add("hidden");
				handleMessage(data.message, true);
			} else {
				handleMessage(data.message, false);
			}
		})
		.catch((error) => {
			console.error("Error:", error);
			handleMessage("Něco se pokazilo! Zkuste to znovu.", false);
		});
};

const handleFileChange = (event: Event) => {
	const input = event.target as HTMLInputElement;
	const file = input.files?.[0];
	const fileResult = document.querySelector("#file-result");

	if (file) {
		const reader = new FileReader();
		reader.onload = () => {
			fileName = file.name;
			fileData = reader.result as string;
			if (fileResult) {
				fileResult.textContent = `Soubor nahrán!`;
			}
		};
		reader.readAsDataURL(file);
	}
};

const handleMessage = (message: string, status: boolean) => {
	const resultAlert = document.querySelector("#result-alert");
	if (resultAlert) {
		resultAlert.textContent = message;
		resultAlert.classList.remove(
			"border-green-500",
			"bg-green-100",
			"text-green-900",
			"border-red-500",
			"bg-red-100",
			"text-red-900",
		);
		if (status) {
			resultAlert.classList.add(
				"border-green-500",
				"bg-green-100",
				"text-green-900",
			);
		} else {
			resultAlert.classList.add(
				"border-red-500",
				"bg-red-100",
				"text-red-900",
			);
		}
		resultAlert.classList.remove("hidden");
	}
};
